module.exports = __webpack_public_path__ + "img/tt-bg.30803907.png";